// extracted by mini-css-extract-plugin
module.exports = {"box":"live-screenshot_box__wn9KQ"};